import { useState } from "react";
import { sanitizeHtml } from "../../../../../../helpers/sanitizeHtml";

type Props = {
    conversation: any;
}

/**
 * Card "EXPERTISE INFO" del panel derecho (Figma 4731:129738).
 *
 * Colapsable con el caret, igual que FILES AND LINKS. Muestra la descripcion del servicio
 * solicitado y su tarifa — el resto de los datos de la solicitud (fechas, estado, solicitante)
 * viven en los Steps y en la card de perfil, no aqui.
 */
export const MessagesExpertiseInfo = ({ conversation }: Props) => {
    const [open, setOpen] = useState(true);

    const request = conversation?.expertiseRequestDetail ??
        conversation?.expertise_request_detail ??
        conversation?.expertiseRequest ??
        conversation?.expertise_request;
    if (!request) return null;

    const service = request.expertise;
    const rate = service?.rate;

    return (
        <div className="expertise-info-card">
            <button
                type="button"
                className="expertise-info-card__header"
                onClick={() => setOpen((prev) => !prev)}
                aria-expanded={open}
            >
                <span className="expertise-info-card__title">Expertise info</span>
                <svg
                    xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none"
                    className={`expertise-info-card__caret${open ? '' : ' expertise-info-card__caret--closed'}`}
                    aria-hidden="true"
                >
                    <path d="M3.75 9.375L7.5 5.625L11.25 9.375" stroke="#151515" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </button>

            {open && (
                <div className="expertise-info-card__body">
                    <span className="expertise-info-card__label">
                        {service?.title || 'Professional Knowledge Sharing'}
                    </span>

                    {/* La descripcion del SERVICIO que el experto ofrece — NO `request.message`,
                        que es lo que el miembro pide. Eso pertenece al hilo, no a esta card.

                        Viene del editor Quill del creador del servicio (HTML: <p>, <strong>,
                        <ul>...), asi que se pasa por sanitizeHtml (mismo wrapper de DOMPurify que
                        usa ExpertiseOfferCard) y se pinta con dangerouslySetInnerHTML. Sin
                        sanitizar, el usuario veria el markup como texto plano (bug 4b) y ademas
                        se abriria XSS de HTML persistido. El modifier `--rich` aplana margenes
                        heredados de Bootstrap para conservar el ritmo compacto de la card. */}
                    {service?.description && (
                        <p
                            className="expertise-info-card__text expertise-info-card__text--rich"
                            dangerouslySetInnerHTML={{ __html: sanitizeHtml(service.description) }}
                        />
                    )}

                    <div className="expertise-info-card__rate">
                        <span className="expertise-info-card__rate-label">Rate</span>
                        <span className="expertise-info-card__rate-value">
                            {rate != null ? `$${Number(rate)}/hour` : 'Custom quote'}
                        </span>
                    </div>
                </div>
            )}
        </div>
    );
}

export default MessagesExpertiseInfo;
